import React, {useEffect, createRef} from 'react';

const DeleteAdminModal = ({ admin, onDelete, onCancel }) => {
  const deletebutton = createRef();

  const handleDelete = () => {
    onDelete()
  };

  const handleCancel = () => {
    onCancel()
  };

  useEffect(() => {
    deletebutton.current.focus();
  }, []);

  return (
    <div className="modal-overlay">
      <div className="modal">
        <p>Are you sure you want to delete: {admin.userName}?</p>
        <div className="button-container">
          <button ref={deletebutton} className="k-button k-button-md k-rounded-md k-button-solid-primary k-button-solid-base delete-btn" onClick={handleDelete}>
            Delete
          </button>
          <button name="cancel" className=" k-button k-button-md k-rounded-md k-button-solid-secondary k-button-solid-base cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAdminModal;